import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import {
  Button,
  Menu,
  MenuItem,
  ListItemText,
  Box,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CodeIcon from '@material-ui/icons/Code';

const styles = (theme) => ({
  button: {
    marginBottom: theme.spacing(1),
  },
  sampleValue: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
});

const GET_MERGE_FIELDS = gql`
  query GetAvailableMergeFields {
    availableMergeFields
  }
`;

const SAMPLE_VALUES = {
  // User profile fields
  'user.name': 'John Smith',
  'user.email': 'john@example.com',
  'user.city': 'San Francisco',
  'user.province': 'CA',
  'user.annual_revenue': '$500,000',
  // URL fields - use these for button CTAs
  'user.messages_url': 'https://yoursite.com/messages',
  'user.valuation_url': 'https://yoursite.com/succession/valuation',
  'user.value_acceleration_url': 'https://yoursite.com/succession/value_acceleration',
  'user.deals_url': 'https://yoursite.com/succession/deals',
  'user.search_url': 'https://yoursite.com/succession/search',
  'user.vault_url': 'https://yoursite.com/succession/vault',
  'user.profile_url': 'https://yoursite.com/succession/profile',
  'user.plans_url': 'https://yoursite.com/succession/plans',
  'user.education_url': 'https://yoursite.com/succession/education',
  'user.home_url': 'https://yoursite.com/succession/home',
  'user.login_url': 'https://yoursite.com/users/sign_in',
  // Company fields
  'company.name': 'YourCompany',
  'company.branded_name': 'Your Platform',
  'company.deal_room_branded_name': 'Your Deal Room',
};

class MergeFieldPicker extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSelect = (field) => {
    const { onInsert } = this.props;
    if (onInsert) {
      onInsert(field);
    }
    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;

    return (
      <Query query={GET_MERGE_FIELDS}>
        {({ loading, error, data }) => (
          <Box>
            <Button
              variant="outlined"
              startIcon={<CodeIcon />}
              onClick={this.handleClick}
              className={classes.button}
            >
              Insert Merge Field
            </Button>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              {data?.availableMergeFields?.map((field) => (
                <MenuItem key={field} onClick={() => this.handleSelect(field)}>
                  <ListItemText
                    primary={`{{${field}}}`}
                    secondary={
                      <Typography className={classes.sampleValue}>
                        Example: {SAMPLE_VALUES[field] || 'Sample Value'}
                      </Typography>
                    }
                  />
                </MenuItem>
              ))}
            </Menu>
          </Box>
        )}
      </Query>
    );
  }
}

MergeFieldPicker.propTypes = {
  classes: PropTypes.object.isRequired,
  onInsert: PropTypes.func,
};

MergeFieldPicker.defaultProps = {
  onInsert: null,
};

export default withStyles(styles)(MergeFieldPicker);
